import { ServiceOrderDto } from "@shared/types/ServiceOrderDto";
import { ApiService } from "./ApiService";
import { WorkOrderTicketDto } from "@shared/types/WorkOrderTicketDto";
import { GetChangeRequestsResponse } from "@shared/types/payloads/GetChangeRequestsResponse";
import { WorkOrderDto } from "@shared/types/WorkOrderDto";

export interface WorkOrderSummary {
  id: string;
  name: string;
  status: string;
  startDate: string;
  dueDate: string;
}

export interface ProjectSummary {
  id: string;
  name: string;
}

export interface SelectWorkOrderRequest {
  invoiceId?: string;
  workOrderId?: string;
  serviceOrderId?: string;
}

export class WorkOrdersService {
  constructor(private readonly apiService: ApiService) {}

  async getServiceOrders(): Promise<ServiceOrderDto[]> {
    return this.apiService.request<ServiceOrderDto[]>("/service-orders/list", {
      method: "GET",
      requireAuth: true,
    });
  }

  async selectWorkOrder(
    request: SelectWorkOrderRequest
  ): Promise<WorkOrderDto> {
    return this.apiService.request<WorkOrderDto>(`/work-orders/select`, {
      method: "POST",
      body: JSON.stringify(request),
      requireAuth: true,
    });
  }
  async getWorkOrderTickets(
    serviceOrderId: string
  ): Promise<WorkOrderTicketDto[]> {
    return this.apiService.request<WorkOrderTicketDto[]>(
      `/work-board/tickets/${serviceOrderId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }
  async getChangeRequests(
    serviceOrderId: string
  ): Promise<GetChangeRequestsResponse[]> {
    return this.apiService.request<GetChangeRequestsResponse[]>(
      `/work-orders/change-requests/${serviceOrderId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }

  async getWorkOrderByServiceOrder(
    serviceOrderId: string
  ): Promise<WorkOrderDto | null> {
    return this.apiService.request<WorkOrderDto | null>(
      `/work-orders/service-order/${serviceOrderId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }

  async updateProjectName(
    serviceOrderId: string,
    customProjectName: string
  ): Promise<ServiceOrderDto> {
    return this.apiService.request<ServiceOrderDto>(
      `/service-orders/${serviceOrderId}/project-name`,
      {
        method: "PATCH",
        body: JSON.stringify({ customProjectName }),
        requireAuth: true,
      }
    );
  }
}
